import { createTrue } from "typescript";
import { CatalogEditingPageState } from "./catalog-editing-page-types";

export const CATALOG_EDITING_PAGE_KEY = "catalog_editing";

export const CATALOG_EDITING_PAGE_INITIAL_STATE: CatalogEditingPageState = {
  modifiedParams: {},
};
